import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';
import * as Plotly from 'plotly.js/dist/plotly.js';
@Directive({
  selector: '[appResizable]'
})
export class ResizableDirective {
  @Input() resizableEdges: string[] = ['right', 'bottom','bottom-right']; // Allow resizing on edges and corners
  @Input() resizePlots: boolean = false;
  private resizing = false;
  private currentEdge = '';
  private startX = 0;
  private startY = 0;
  private startWidth = 0;
  private startHeight = 0;

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.currentEdge = this.getEdge(event);
    if (this.resizableEdges.includes(this.currentEdge)) {
      this.resizing = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.startWidth = this.el.nativeElement.offsetWidth;
      this.startHeight = this.el.nativeElement.offsetHeight;

      event.preventDefault();
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.resizing) {
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;

      switch (this.currentEdge) {
        case 'right':
          this.renderer.setStyle(this.el.nativeElement, 'width', `${this.startWidth + deltaX}px`);
          break;
        case 'bottom':
          this.renderer.setStyle(this.el.nativeElement, 'height', `${this.startHeight + deltaY}px`);
          break;
        case 'bottom-right':
          this.renderer.setStyle(this.el.nativeElement, 'width', `${this.startWidth + deltaX}px`);
          this.renderer.setStyle(this.el.nativeElement, 'height', `${this.startHeight + deltaY}px`);
          break;
      }

      event.preventDefault();
    } else {
      const cursorStyle = this.getCursorStyle(this.getEdge(event));
      this.renderer.setStyle(this.el.nativeElement, 'cursor', cursorStyle);
    }
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    if(this.resizing){
      this.resizing = false;
    if(this.resizePlots){
    const plotlyGraph = this.el.nativeElement.querySelector('.js-plotly-plot');
      if (plotlyGraph) {
        Plotly.Plots.resize(plotlyGraph);
      }}
    this.renderer.removeStyle(this.el.nativeElement, 'cursor');
    }
  }

  private getEdge(event: MouseEvent): string {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const offset = 10; // Sensitivity for detecting the edges

    if (event.clientX > rect.right - offset && event.clientY > rect.bottom - offset) {
      return 'bottom-right';
    }

    if (event.clientX > rect.right - offset) {
      return 'right';
    }  else if (event.clientY > rect.bottom - offset) {
      return 'bottom';
    }

    return '';
  }

  private getCursorStyle(edge: string): string {
    switch (edge) {
      case 'right':
        return 'ew-resize';
      case 'bottom':
        return 'ns-resize';
      case 'bottom-right':
        return 'nwse-resize';
      default:
        return 'default';
    }
  }
}
